import * as React from 'react'
import {Box, Typography, Button} from '@mui/material'
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined'
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined'
import {FONT, SIZE, WEIGHT} from '../../../styles/foundation/typography'
import {NAVY, SUBTLE, PRIMARY_BLUE, withOpacity} from '../../../styles/foundation/colors'

// Modelled on the /claims empty state (src/app/components/claims/AllClaims.js —
// the "No filters applied yet" block): a tinted icon circle, a bold headline,
// one line of subtle explanatory copy, and an optional action underneath.
// Two distinct cases share this shell but never share copy — a tab with
// nothing in it is a different situation from filters over-narrowing a tab
// that does have rows, and merchants need to know which one they're looking at.
export default function EmptyState({variant = 'no-match', onClearFilters}) {
  const isTabEmpty = variant === 'tab-empty'
  const Icon = isTabEmpty ? InboxOutlinedIcon : FilterAltOffOutlinedIcon

  const headline = isTabEmpty ? 'Nothing here right now' : 'No discrepancies match your filters'
  const body = isTabEmpty
    ? 'There are no discrepancies in this tab yet. New weight discrepancies will show up here as couriers apply them.'
    : 'No discrepancies match the current date range, search or courier filters. Try widening your search.'

  return (
    <Box sx={{p: 5, textAlign: 'center'}}>
      <Box sx={{
        width: 48, height: 48, borderRadius: '10px', mx: 'auto', mb: 1.5,
        bgcolor: withOpacity(PRIMARY_BLUE, 0.12), color: PRIMARY_BLUE,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <Icon />
      </Box>
      <Typography sx={{fontFamily: FONT, fontWeight: WEIGHT.bold, fontSize: SIZE.sm, color: NAVY}}>
        {headline}
      </Typography>
      <Typography sx={{fontFamily: FONT, color: SUBTLE, fontSize: SIZE['2xs'], mt: 0.5, maxWidth: 360, mx: 'auto'}}>
        {body}
      </Typography>
      {!isTabEmpty && onClearFilters && (
        <Button
          size='small'
          onClick={onClearFilters}
          sx={{fontFamily: FONT, fontSize: SIZE['2xs'], textTransform: 'none', mt: 1.5}}
        >
          Clear filters
        </Button>
      )}
    </Box>
  )
}
